import dashboardServices from "../services/hoa-dashboard-api-service";
import datastore from "../store/hoa-datastore";
import config from "../hoa-config";
import {
	createExcelHoaList,
	createExcelPropertyList,
	createExcelForMailList,
	createExcelForEmailList
} from "../utility/create-excel-from-list";

export default function useExcelSheetDownload() {
	const userConfirmWindowAlert = () => {
		return window.confirm("This list includes many rows (1000+). Do you wish to continue?");
	};

	const hoaDataDownloadInExcel = async (hoa: any, setIsDownloadingHoaList: any) => {
		setIsDownloadingHoaList(true);
		let hoaRowDataList: any = [];
		const numberOfHoas = 1000;

		if (hoa.count >= numberOfHoas) {
			if (!userConfirmWindowAlert()) {
				setIsDownloadingHoaList(false);
				return;
			}
		}

		if (hoa.count > 0) {
			for (let page = 1; page <= Math.ceil(hoa.count / numberOfHoas); page++) {
				const { data } = await dashboardServices.getFilteredHoaListXlSheet(
					numberOfHoas,
					page,
					hoa.options,
					datastore.selectedOrganization?.id
				);
				for (let hoaRow of data.hoas) {
					hoaRowDataList.push(hoaRow);
				}
			}
			const header = [
				"HOA Name",
				"IM HOA ID",
				"PMC",
				"Market",
				"City",
				"HOA Address",
				"No. of Properties",
				"Last Updated",
				"Type",
			];
			createExcelHoaList(header, hoaRowDataList);
		}
		setIsDownloadingHoaList(false);
	};

	const propertyDataDownloadInExcel = async (
		property: any,
		setIsDownloadingPropertyList: any
	) => {
		setIsDownloadingPropertyList(true);
		let propertyRowDataList: any = [];
		const numberOfProperties = 1000;

		if (property.count >= numberOfProperties) {
			if (!userConfirmWindowAlert()) {
				setIsDownloadingPropertyList(false);
				return;
			}
		}

		if (property?.count > 0) {
			for (let page = 1; page <= Math.ceil(property?.count / numberOfProperties); page++) {
				const { data } = await dashboardServices.getFilteredPropertyListXlSheet(
					numberOfProperties,
					page,
					property.options,
					datastore.selectedOrganization?.id
				);

				for (let property of data.properties) {
					propertyRowDataList.push(property);
				}
			}
			const headers = [
				"Property Address",
				"IM Property ID",
				"External ID",
				"City",
				"Organization",
				"Market",
				"Last Updated",
				"Tag",
				"Added By",
			];
			createExcelPropertyList(headers, propertyRowDataList);
		}
		setIsDownloadingPropertyList(false);
	};

	const mailDataDownloadInExcel = async (
		mail: any,
		setDownLoadedLoading: any,
		setModalOpen: any
	) => {
		if (mail.count > 1000) {
			if (!userConfirmWindowAlert()) {
				setDownLoadedLoading(false);
				setModalOpen(false);
				return;
			}
		}

		setDownLoadedLoading(true);

		const ceilingValue = Math.ceil(mail.count / 1000);
		const options = mail.options || {};
		let output: any = [];
		const promises = Array.from({ length: ceilingValue }, (_, i) => {
			const page = i + 1;
			return dashboardServices.getMails(1000, page, options);
		});
		const results = await Promise.all(promises);
		output = results.flatMap(({ data }) => data.mails || []);

		createExcelForMailList(output);

		setDownLoadedLoading(false);
		setModalOpen(false);
	};

	const emailDataDownloadInExcel = async (
		email: any,
		setDownLoadedLoading: any,
		setModalOpen: any
	) => {
		if (email.count > 1000) {
			if (!userConfirmWindowAlert()) {
				setDownLoadedLoading(false);
				setModalOpen(false);
				return;
			}
		}

		setDownLoadedLoading(true);

		const ceilingValue = Math.ceil(email.count / 1000);
		const options = email.options || {};
		let output: any = [];
		const promises = Array.from({ length: ceilingValue }, (_, i) => {
			const page = i + 1;
			return dashboardServices.getEmails(1000, page, options);
		});
		const results = await Promise.all(promises);
		output = results.flatMap(({ data }) => data.emails || []);

		createExcelForEmailList(output);

		setDownLoadedLoading(false);
		setModalOpen(false);
	};

	return {
		hoaDataDownloadInExcel,
		propertyDataDownloadInExcel,
		mailDataDownloadInExcel,
		emailDataDownloadInExcel
	};
}
